<template>
    <div class="ngdialog-content">
        <div class="ngdialog__header">
            <h4>{{ $t('systems.logs.reset') }}</h4>
            <div class="ngdialog-close" @click="$emit('close')"></div>
        </div>

        <table class="table table--striped table--filterable">
            <table-filter v-bind:filterOptions="filterOptions" v-on:input="applyFilter" v-on:sorting="sortData">
                <th width="17%"></th>
            </table-filter>
            <paginate name="filteredAlarms" :list="filteredAlarms" tag="tbody" v-if="filteredAlarms.length" :per="paginationSiteSize" ref="paginator">
                <tr v-for="alarm in paginated('filteredAlarms')" :key="alarm.id">
                    <td>{{ alarm.nodeName }}</td>
                    <td class="centered">
                        <alarm-message :alarm="alarm" />
                    </td>
                    <td>{{ alarm.timestamp }}</td>
                    <td>{{ alarm.active_formatted }}</td>
                    <td>
                        <span v-if="pending" class="button button--inactive">{{ $t('common.loading') }}</span>

                        <a v-if="!pending && alarm.active && alarm.resettable" class="button button--primary" @click="resetRemoteAlarm(alarm.id)">{{ $t('systems.logs.reset') }}</a>

                        <a v-if="!pending && (!alarm.active || !alarm.resettable)" class="button button--inactive">{{ $t('systems.logs.reset') }}</a>
                    </td>
                </tr>
            </paginate>

            <tfoot>
                <tr>
                    <td colspan="5">
                        <div class="pagination">
                            <paginate-links
                                for="filteredAlarms"
                                :simple="{ next: $t('common.next') + ' >', prev: '< ' + $t('common.previous') }"
                                v-if="filteredAlarms.length"
                                :async="true"
                            ></paginate-links>
                            <div class="pagination__site" v-if="filteredAlarms.length > paginationSiteSize">
                                {{ paginationSiteSize * paginate.filteredAlarms.page + 1 }} {{ $t('common.to') }}
                                {{ paginate.filteredAlarms.list.length + paginationSiteSize * paginate.filteredAlarms.page }} {{ $t('common.from') }} {{ filteredAlarms.length }}
                            </div>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import * as api from '@/api';
import TableFilter from '@/components/TableFilter';
import AlarmMessage from '@/components/AlarmMessage';
import filterForTable from '@/mixins/filterForTable';
import store from '@/store';

export default {
    components: {
        TableFilter,
        AlarmMessage,
    },
    mixins: [filterForTable],
    props: {
        remoteAlarms: Array,
        systemId: String,
    },
    data() {
        return {
            alarms: this.remoteAlarms,
            paginationSiteSize: 12,
            filterQueries: false,
            paginate: ['filteredAlarms'],
            sortingOptions: false,
            pending: false,
            filterOptions: [
                {
                    attribute: 'nodeName',
                    translation: 'systems.logs.source_of_error',
                    width: '22%',
                },
                {
                    attribute: 'error_code_formatted',
                    translation: 'systems.logs.number',
                    width: '18%',
                },
                {
                    attribute: 'timestamp',
                    translation: 'systems.logs.date_and_time',
                    width: '28%',
                },
                {
                    attribute: 'active_formatted',
                    translation: 'systems.logs.active',
                    width: '15%',
                },
            ],
        };
    },
    computed: {
        filteredAlarms() {
            let filteredSystems = this.filterForTable(this.alarms, this.filterQueries, this.sortingOptions);

            return filteredSystems;
        },
    },
    methods: {
        applyFilter(queries) {
            this.filterQueries = queries;
        },
        sortData(sorting) {
            this.sortingOptions = sorting;
        },
        resetRemoteAlarm(id) {
            this.pending = true;

            api.systems.resetRemoteAlarm({ id: this.systemId, alarmId: id }).then(
                response => {
                    this.pending = false;
                    store.commit('setAlarmCheckId', id);
                    this.$emit('close');
                    this.$notify({
                        type: 'success',
                        text: this.$t('systems.logs.success_reset_remote_alarm'),
                    });
                },
                () => {
                    this.pending = false;
                    this.$notify({
                        type: 'error',
                        text: this.$t('systems.logs.error_reset_remote_alarm'),
                    });
                }
            );
        },
    },
};
</script>
